define('lq/multiSourceValue',[
    'lq/parameterBinding'
], function(parameterBinding) {

    const sources = {
        VALUE: 'value',
        PARAMETER: 'parameter'
    };

    var createEmptyValue = function(defaultFixedValue, useParameterByDefault) {
        return {
            source: useParameterByDefault ? sources.PARAMETER : sources.VALUE,
            fixedValue: defaultFixedValue,
            parameter: {
                name: "",
                autoUpdate: false
            }
        };
    };
    
    var getValue = function(drop, multiSourceValue) {
        if (multiSourceValue.source === sources.VALUE)
            return multiSourceValue.fixedValue;
        
        if (multiSourceValue.source === sources.PARAMETER)
            return parameterBinding.getValue(drop, multiSourceValue.parameter);
        
        return undefined;
    };

    var initialize = function(drop, multiSourceValue, valueSetter) {
        if(!multiSourceValue) return;
        
        if(multiSourceValue.source === sources.VALUE) {
            var initialValue = multiSourceValue.fixedValue;
            valueSetter(initialValue);
        } else if (multiSourceValue.source === sources.PARAMETER) {
            parameterBinding.initialize(drop, multiSourceValue.parameter, valueSetter);
        }
    };

    var initializeUpdates = function(drop, multiSourceValue, valueSetter) {
        if(!multiSourceValue) return;

        if (multiSourceValue.source === sources.PARAMETER)
            parameterBinding.initializeUpdates(drop, multiSourceValue.parameter, valueSetter);
    };
    
    var getParameterName = function(value) {
        if(value && value.source === sources.PARAMETER && value.parameter && value.parameter.name)
            return value.parameter.name;
        return undefined;
    };

    return {
        sources: sources,
        createEmptyValue: createEmptyValue,
        initialize: initialize,
        initializeUpdates: initializeUpdates,
        getValue: getValue,
        getParameterName: getParameterName
    };
    
});
